"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setContext = exports.initState = void 0;
const react_1 = require("react");
exports.initState = {
    secretKey: '',
    handleSecretKey: (secretKey) => { },
};
function setContext() {
    const [secretKey, setSecretKey] = (0, react_1.useState)('');
    const handleSecretKey = (secretKey) => {
        if (secretKey.length > 0)
            setSecretKey(secretKey);
    };
    return {
        secretKey,
        handleSecretKey
    };
}
exports.setContext = setContext;
